import { v4 as uuidv4 } from 'uuid'
import { axios } from '../axios'
import { useMutation } from '@tanstack/react-query'
import { ExtractFnReturnType } from 'apis/queryConfig'
import { AxiosResponse } from 'axios'
import { Dispatch, SetStateAction } from 'react'

type IUploadActionTrackerLoadsheet = {
  project_id: string
  asset_id: string | null
  params?: { [key: string]: any; }
  payload: any
  setUploadPercentage: Dispatch<SetStateAction<number>>
  signal: AbortSignal
}
export async function UploadActionTrackerLoadsheet({
  project_id,
  asset_id,
  payload,
  setUploadPercentage,
  signal,
  params
}: IUploadActionTrackerLoadsheet): Promise<AxiosResponse<Blob>> {
  return axios.post(
    `oe/action-management/project/${project_id}/asset/${asset_id}/loadsheet`,
    payload,
    
    {
      params,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      signal: signal,
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent
        const percent = Math.round((loaded * 100) / (total || 1))
        setUploadPercentage(percent)
      },
    }
  )
}
export type UploadActionTrackerLoadsheet = ExtractFnReturnType<typeof UploadActionTrackerLoadsheet>

export const useActionTrackerLoadsheetUpload = () => {
  return useMutation<UploadActionTrackerLoadsheet, Error, IUploadActionTrackerLoadsheet>({
    mutationKey: ['actionTrackerLoadsheetUpload'],
    mutationFn: (data) => UploadActionTrackerLoadsheet(data),
  })
}
